import axios from 'axios';

const setChannelPartnersHeader = () => {
  axios.defaults.headers.common['ChannelPartners'] = `true`;
};

export default setChannelPartnersHeader;
